import LandingPage from "../pages/landing";
import AboutPage from "../pages/about";
import ContactPage from "../pages/contact";
import ProjectPage from "../pages/projects";
import ProjectDetails from "../pages/projects-details";
import { PrivacePolicyPage } from "../pages/privace-policy";
import MontessoriHubPage from "../pages/montessori";
import { ROUTE } from "../utils/constants";

const routes = [
  { paths: ["*"], element: <LandingPage /> },
  { paths: [ROUTE.home], element: <LandingPage /> },
  { paths: [ROUTE.about, ROUTE.sobre], element: <AboutPage /> },
  { paths: [ROUTE.project, ROUTE.projetos], element: <ProjectPage /> },
  { paths: [ROUTE.contact, ROUTE.contato], element: <ContactPage /> },
  { paths: [ROUTE.policy, ROUTE.politica], element: <PrivacePolicyPage /> },
  { paths: [ROUTE.projectDetails], element: <ProjectDetails /> },
  { paths: [ROUTE.montessori], element: <MontessoriHubPage /> },
];

export default routes;
